var render = function render(){var _vm=this,_c=_vm._self._c;return _c('searches-groups-list-page',{attrs:{"resource-name":"tag_library","is-initiated":_vm.tagsSearchesAreInitiated,"hide-filters":true,"data":_vm.tagsSearchesData,"no-data":_vm.tagsSearchesNoData,"all-loaded":_vm.tagsSearchesAllLoaded,"can-load-more-string":"tagsSearchesCanLoadMore","is-busy":_vm.tagsSearchesAreBusy}})
}
var staticRenderFns = []

export { render, staticRenderFns }